<div class="divider-dot" [style.width.px]="size()" [style.height.px]="size()"></div>
